<div class="card form-grid">
  @if (this.addAllowed && this.currentConfig.formType!=undefined && this.currentConfig.formType == 'default' && !this.currentConfig.hideHeader) {
    <div class="card-header d-flex justify-content-between align-items-center">
      <!-- <div class="pr-2" *ngIf="baseService && baseService._currentTitle">
      <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
        <img src="assets/images/grid-back.png" />
      </a>
    </div> -->
    @if (baseService && baseService._currentTitle) {
      <h4 class="kx-bold">
        {{baseService._currentTitle}}
      </h4>
    }
    @if (currentConfig.showTile == undefined || currentConfig.showTile) {
      <span class="_wf-cf-dropdownicon" (click)="tiltIcon()" style="float: right;">
        @if (!_currentData.tilt) {
          <i class="fa fa-angle-down"></i>
        }
        @if (_currentData.tilt) {
          <i class="fa fa-angle-up"></i>
        }
      </span>
    }
  </div>
}
<div class="card-body">
  @if (this.currentConfig.formType!=undefined && this.currentConfig.formType == 'default') {
    <div class="">
      @if (_currentData.showBanner && parent_id == 0 && !this.currentConfig.hideCompleteHeader) {
        <div>
          @if (_currentData.bannerJson.component == undefined) {
            <app-resource-banner
            [bannerJson]="_currentData.bannerJson"></app-resource-banner>
          }
        </div>
      }
      <!-- {{currentConfig|json}} -->
      <!-----Page title-->
      @if (this.currentConfig.hideHeader && currentConfig.showNavigationwithBanner && this.currentConfig.showNavigationAfterBanner) {
        <div class="page-title-container d-flex pl-2 pr-2">
          @if (!utilService.isMobile()) {
            <div class="page-title">
              <div class="mb-0">
                <div class="d-flex align-items-center">
                  <div class="pr-2">
                    <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
                      <img src="assets/images/grid-back.png" />
                    </a>
                  </div>
                  @if (baseService && baseService._currentTitle) {
                    <div class="">
                      {{baseService._currentTitle}}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!-----Page title-->
      @if (_currentData.currentFormFields) {
        <div [hidden]="_currentData.tilt" [ngClass]="(currentConfig.aside_container || currentConfig.submitRefresh)? '' : 'row pl-3 pr-3'">
          <div [ngClass]="(currentConfig.aside_container || currentConfig.submitRefresh)? '' : 'col-12 pl-3 pr-3 fg_seperator'">
            @if (_currentData.currentAction == 'ADD') {
              @if (this.addAllowed && _currentData.currentFormFields) {
                <dhs-form [action]="_currentData.currentAction"
                  [bookmarks]="_currentData.bookmarks" [fieldGroup]="_currentData.currentFormFields"
                  [data]="_currentData.currentData"
                  [customButton]="_currentData.customButton" [config]="_currentData.config"
                  [decorator]="_currentData.decorator" (saveFinished)="onSaveFinished($event)"
                  #formComponenet>
                </dhs-form>
              }
            }
            @if (_currentData.currentAction == 'MODIFY' && editonPage) {
              @if (_currentData.currentFormFields) {
                <dhs-form [action]="_currentData.currentAction"
                  [bookmarks]="_currentData.bookmarks"
                  [fieldGroup]="_currentData.currentFormFields" [data]="_currentData.currentData"
                  [customButton]="_currentData.customButton" [config]="_currentData.config"
                  [decorator]="_currentData.decorator" (saveFinished)="onSaveFinished($event)"
                  #formComponenet>
                </dhs-form>
              }
            }
          </div>
        </div>
      }
    </div>
  }
  @if (this.addAllowed && this.currentConfig.formType!=undefined && this.currentConfig.formType == 'aside' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && this._currentData.addAllowed) {
    <div class="d-flex justify-content-end"
      >
      @if (!utilService.isMobile();) {
        <button class="primary-btn mt-2" (click)="setAsideView()">
          <span>{{(currentConfig && currentConfig.addButton)?(currentConfig.addButton|
            translate | async):'button.add'
            |
          translate | async}}</span>
          <i class="fa fa-plus-circle"></i>
        </button>
      }
      <!--for mobile fixed button-->
      @if (utilService.isMobile();) {
        <button class="mobile-primary-btn" (click)="setAsideView()">
          <i class="fa fa-plus"></i>
          <div>{{(currentConfig && currentConfig.addButton)?(currentConfig.addButton|
            translate | async):'button.add'
            |
          translate | async}}</div>
        </button>
      }
    </div>
  }

  <div class="mt-2">
    @if (_currentData.currentListFields && _currentData.showView == true) {
      <dhs-data-grid [fields]="_currentData.currentListFields"
        [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList"
        [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick"
        [config]="_currentData.configList" (bulkActionClicked)="onBulkActionClicked($event)"
        (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)"
        (onFilterChange)="filterChange($event)" (onPageChanges)="pageChanges($event)"
        (onSortChanges)="sortChanges($event);" (configValues)="getConfigValues($event)" (editEllipseClick)="buttonAction($event)" (bannerRefreshClick)="refreshGridBanner($event);">
      </dhs-data-grid>
    }
  </div>
</div>
</div>